import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({

    // Scrollbar
    '@global': {
        '*::-webkit-scrollbar': {
            width: '0.4em'
        },
        '*::-webkit-scrollbar-track': {
            '-webkit-box-shadow': 'inset 0 0 6px rgba(0,0,0,0.00)'
        },
        '*::-webkit-scrollbar-thumb': {
            backgroundColor: 'rgba(0,0,0,.1)',
            outline: '1px solid slategrey'
        }
    },

    compete_main: {
        display: "flex",
        flexDirection: "column"
    },
    dir: {
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center",
    },
    scores: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        overflowY: "auto",
        overflowX: "hidden",
        scrollbarWidth: "thin",
        padding: "0px 30px",
        maxHeight: "65vh"
    },
    back_home: {
        paddingLeft: "10px",
        maxWidth: "20px",
    },
    back_home_container: {
        maxWidth: '60px',
        minWidth: '60px',
        maxHeight: '35px',
        minHeight: '35px'
    },
    title: {
        color: "white",
        filter: "drop-shadow(3px 3px 2px #000000c4)",
        margin: "20px"
    },
    paper: {
        padding: "20px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        width: "900px"
    },
    post_new_users_content: {
        display: "flex",
        flexWrap: "wrap",
        maxHeight: "55px",
        overflow: "auto"
    },
    post_row: {
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-start",
        height: "50px",
    },
    people_icon: {
        padding: "0px 8px 0px 6px"
    },
    post_news_row: {
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start",
        justifyContent: "flex-start",
        margin: "8px 0px 0px 13px",
        width: "600px",
    },
    preview: {
        maxWidth: "625px",
        marginBottom: "25px",
        backgroundColor: "#a2e9e13d",
        borderRadius: "8px",
        border: "2px solid #5a858011",
        padding: "20px",
        /* Para evitar copia-pega usuario   */
        pointerEvents: "none",
        userSelect: "none",
        fontSize: "18px"
    },
    field: {
        marginTop: "20px",
        width: "100%",
        maxWidth: "500px",
    },

    url_select: {
        maxWidth: "150px",
    },
    my_compete_paper: {
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center",
        padding: "8px",
        width: "570px",
        margin: "8px auto",
    },
    user_paper: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
        alignItems: "center",
        padding: "10px",
        width: "720px",
        margin: "10px auto",
    },
    others_compete_paper: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "10px",
        width: "450px",
        margin: "10px auto",
    },
    arriba: {
        display: "flex",
    },
    abajo: {
        display: "flex",
    },
    left: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        margin: "10px 25px 0px 10px"
    },
    others_left: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },
    center: {
        flexGrow: "1",
        padding: "0px 15px 0px 0px"
    },
    post_users_content: {
        display: "flex",
        overflow: "hidden",
    },
    post_users: {
        display: "flex",
        alignItems: "center",
        width: "587px",
        whiteSpace: "nowrap",
    },
    post_tag: {
        maxWidth: "232px",
        display: "flex",
        alignItems: "center",
        whiteSpace: "nowrap",
        margin: "12px 0px",
    },
    post_users_button: {
        height: "35px",
        padding: "0px 10px",
        margin: "5px",
        backgroundColor: "#ffffff",
        borderRadius: "5px",
        border: "1px solid gray"
    },
    example_news: {
        marginBottom: "20px",
        padding: "10px 20px",
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "space-between",
        alignItems: "center",
        "& p": {

            borderRadius: "5px",
            border: "2px solid rgba(0, 0, 0, 0.219)",
            backgroundColor: "#44d1c144",
        }
    },
    post_tag_button: {
        height: "35px",
        padding: "0px 10px",
        margin: "5px",
        borderRadius: "5px",
        padding: "5px 10px",
        border: "2px solid rgba(0, 0, 0, 0.219)",
        backgroundColor: "#44d1c144",
    },
    post_new_tag: {
        display: "flex",
        alignItems: "center",
        whiteSpace: "nowrap",
        margin: "12px 0px",
    },
    post_new_tag_content: {
        display: "flex",
        overflowX: "auto",
        width: "541px",
    },
    tag_icon: {
        padding: "0px 8px 0px 6px"
    },
    post_tag_content: {
        display: "flex",
        overflow: "hidden",
    },
    add_button_container: {
        marginLeft: "-10px"
    },
    add: {
        color: "#006459",
        filter: "drop-shadow(3px 3px 2px #51bbafa6)",
    },
    post_new_row: {
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-start",
        margin: "0px 0px 0px 13px",
        width: "600px"
    },
    post_title: {
        maxWidth: "290px",
        fontWeight: "bold",
        fontSize: "20px",
    },
    right: {
        textAlign: "center",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        width: "80px",
        "& h1": {
            width: "40px",
            padding: "5px",
            margin: "0px",
            borderRadius: "5px",
            border: "2px solid rgba(0, 0, 0, 0.219)",
            backgroundColor: "#44d1c144",
        }
    },
    img: {
        margin: "0px 20px",
        borderRadius: "10px",
        border: "2px solid rgba(28, 97, 65, 0.89)",
    },
    rss_paper_c: {
        margin: "5px",
        marginRight: "20px",
        padding: "5px 5px",
        borderRadius: "5px",
        border: "2px solid rgba(0, 0, 0, 0.219)",
        backgroundColor: "#44d1c144",
    },
    rss_paper: {
        marginBottom: "20px",
        padding: "0px 20px 18px",
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "space-between",
        alignItems: "center",
        "& p": {
            padding: "5px 10px",
            borderRadius: "5px",
            border: "2px solid rgba(0, 0, 0, 0.219)",
            backgroundColor: "#44d1c144",
        }
    },
    perfil: {
        width: "60px",
        margin: "5px 20px 0px",
        borderRadius: "5px",
    },
    my_score: {
        margin: "10px 0px 15px",
    },
    perfil_otros: {
        width: "60px",
        borderRadius: "5px",
        margin: "2px 5px"
    },
    hr: {
        width: "500px",
    },
    arrowUp: {
        color: "green",
    },
    arrowDown: {
        color: "red",
    },
    ganado_fila: {
        display: "flex",
        alignItems: "baseline",
        justifyContent: "space-around",
        width: "200px"
    },
    ganado_columna: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
    },
    espadas: {
        width: "40px",
    },
    puntos: {
        margin: "0px 20px",
    },
    logIn: {
        margin: "auto"
    },
    paper_container: {
        width: "650px",
        margin: "25px auto",
        filter: "drop-shadow(2px 2px 5px #ffffff)",
    },
    // Backdrop

    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff',
        backgroundColor: "#03040ac4",
        display: "flex",
        flexDirection: "column",
    },
    span: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        overflow: "auto"
    },
    closeButon: {
        color: "white",
        filter: "drop-shadow(2px 2px 10px #ffffff)",
    },
    close: {
        marginTop: 30,
        fontSize: 50,
    },
    juego: {
        margin: "0px 70px 25px"
    },
    compete_content: {
        display: "flex",
        justifyContent: "center",
        alignItems: "flex-start"
    },
    records: {
        padding: "0px 25px"
    },
    records_row: {
        display: "flex",
        justifyContent: "flex-start",
        alignItems: "center"
    },
    records_title: {
        textAlign: "center"
    }
}))